import classNames from 'classnames';
import { IModule } from 'redux-state/layout/types.js';
import { IModuleConfig } from 'redux-state/layout/types.modules.js';
import { moduleHasTitle } from 'utilities/layout.js';
import { modulePathIsSidebar } from 'utilities/modulePath/layout-modulepath.js';
import { TileBodyButton } from './tile-body-header-v2-button.js';

interface ITileBodyHeader extends IModule<IModuleConfig> {
  titleDefault?: string;
  classes?: string;
  children?: React.ReactNode;
}

/**
 * The TileBodyHeader element for use within a Tile module. Overrides module is contains Maintenance or ContextualWarning
 * Most modules will use this, otherwise a module can have it's own custom TileBodyHeader,
 * @deprecated Use TileBodyHeaderV2 instead.
 */
export const TileBodyHeader = ({ children, ...props }: ITileBodyHeader) => {
  const isSidebar = modulePathIsSidebar(props.modulePath);

  const {
    titleDefault,
    classes,
    config: { title, subtitle, link },
  } = props;

  if (!moduleHasTitle(props)) {
    return null;
  }

  const actualTitle = title || titleDefault;

  return (
    <div data-module="tile-body-header" className={classNames('Tile-body-header', classes)}>
      {actualTitle && <h2 className={isSidebar ? '' : 'h1'}>{actualTitle}</h2>}

      {subtitle && <h3 className="h4 u-textRegular u-mT-xs">{subtitle}</h3>}

      {children}
      {!children && !isSidebar && link && <TileBodyButton link={link} />}
    </div>
  );
};
